require('./bootstrap');

import {createApp, h} from 'vue';
import {createInertiaApp, Head, Link} from '@inertiajs/inertia-vue3';
import {InertiaProgress} from '@inertiajs/progress';
import vueMixin from './includes/vue-mixin.js'
import Toasts from "@/includes/toasts";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({el, app, props, plugin}) {
        return createApp({render: () => h(app, props)})
            .use(plugin)
            .use(Toasts)
            .use(VueSweetalert2)
            .component('InertiaHead', Head)
            .component('InertiaLink', Link)
            .mixin(vueMixin)
            .mount(el);
    },
});

InertiaProgress.init({color: '#7e3af2'});
